import React from "react";
import { Instagram } from "lucide-react";
import Person from "../images/person.jpg";

function Team() {
  return (
    <div className=" relative mt-[8rem] mx-4">
      <h1 className="text-[11rem] opacity-10 font-bold hidden lg:block absolute top-[-2.5rem]">
        the squad
      </h1>
      <h2 className="text-[2.5rem] md:pt-[8rem]  border-b border-white mr-[5rem] pl-6 lg:border-none lg:pl-[12rem]">
        <span className="hidden md:inline">meet</span> the team
      </h2>
      <div className="my-12 flex flex-wrap gap-[1.5rem] lg:gap-[1rem] justify-center xl:gap-[3rem]">
        <div className="relative rounded-[5px] border-2 border-[#747474] md:w-[16rem] lg:w-[18rem] xl:w-[22rem]">
          <img className="rounded-[5px] w-full  md:max-h-[16rem] lg:max-h-[20rem] object-cover" src={Person} alt="tristan" />
          <div className="overlay absolute inset-0 rounded-[5px] bg-[#ff4e00] opacity-20 hover:opacity-90 transition-opacity duration-300">
            <div className="flex flex-col justify-between h-full p-4">
              <p className="text-[1.25rem] text-white">jhene aiko</p>
              <a
                href="https://www.gianpinili.com"
                className="text-[1.25rem] text-white"
                target="_blank"
                rel="noreferrer"
              >
                <Instagram className="hover:scale-110 hover:duration-150" />
              </a>
            </div>
          </div>
        </div>
        <div className="relative rounded-[5px] border-2 border-[#747474] md:w-[16rem] lg:w-[18rem] xl:w-[22rem]">
          <img className="rounded-[5px] w-full md:max-h-[16rem] object-cover lg:max-h-[20rem]" src={Person} alt="tristan" />
          <div className="overlay absolute inset-0 rounded-[5px] bg-[#1a1a1a] opacity-20 hover:opacity-90 transition-opacity duration-300">
            <div className="flex flex-col justify-between h-full p-4">
              <p className="text-[1.25rem] text-white">chloe decker</p>
              <a
                href="https://www.gianpinili.com"
                className="text-[1.25rem] text-white"
                target="_blank"
                rel="noreferrer"
              >
                <Instagram className="hover:scale-110 hover:duration-150" />
              </a>
            </div>
          </div>
        </div>
        <div className="relative rounded-[5px] border-2 border-[#747474] md:w-[16rem] lg:w-[18rem] xl:w-[22rem]">
          <img className="rounded-[5px] w-full md:max-h-[16rem] lg:max-h-[20rem] object-cover" src={Person} alt="tristan" />
          <div className="overlay absolute inset-0 rounded-[5px] bg-[#1a1a1a] opacity-20 hover:opacity-90 transition-opacity duration-300">
            <div className="flex flex-col justify-between h-full p-4">
              <p className="text-[1.25rem] text-white">mia shady</p>
              <a
                href="https://www.gianpinili.com"
                className="text-[1.25rem] text-white"
                target="_blank"
                rel="noreferrer"
              >
                <Instagram className="hover:scale-110 hover:duration-150" />
              </a>
            </div>
          </div>
        </div>
        <div className="relative rounded-[5px] border-2 border-[#747474] md:w-[16rem] lg:w-[18rem] xl:w-[22rem]">
          <img className="rounded-[5px] w-full md:max-h-[16rem] object-cover lg:max-h-[20rem]" src={Person} alt="tristan" />
          <div className="overlay absolute inset-0 rounded-[5px] bg-[#1a1a1a] opacity-20 hover:opacity-90 transition-opacity duration-300">
            <div className="flex flex-col justify-between h-full p-4">
              <p className="text-[1.25rem] text-white">ella lucy</p>
              <a
                href="https://www.gianpinili.com"
                className="text-[1.25rem] text-white"
                target="_blank"
                rel="noreferrer"
              >
                <Instagram className="hover:scale-110 hover:duration-150" />
              </a>
            </div>
          </div>
        </div>
        <div className="relative rounded-[5px] border-2 border-[#747474] md:w-[16rem] lg:w-[18rem] xl:w-[22rem]">
          <img className="rounded-[5px] w-full md:max-h-[16rem] lg:max-h-[20rem] object-cover" src={Person} alt="tristan" />
          <div className="overlay absolute inset-0 rounded-[5px] bg-[#1a1a1a] opacity-20 hover:opacity-90 transition-opacity duration-300">
            <div className="flex flex-col justify-between h-full p-4">
              <p className="text-[1.25rem] text-white">dani jayson</p>
              <a
                href="https://www.gianpinili.com"
                className="text-[1.25rem] text-white"
                target="_blank"
                rel="noreferrer"
              >
                <Instagram className="hover:scale-110 hover:duration-150" />
              </a>
            </div>
          </div>
        </div>
        <div className="relative rounded-[5px] border-2 border-[#747474] md:w-[16rem] lg:w-[18rem] xl:w-[22rem]">
          <img className="rounded-[5px] w-full md:max-h-[16rem] lg:max-h-[20rem] object-cover" src={Person} alt="tristan" />
          <div className="overlay absolute inset-0 rounded-[5px] bg-[#1a1a1a] opacity-20 hover:opacity-90 transition-opacity duration-300">
            <div className="flex flex-col justify-between h-full p-4">
              <p className="text-[1.25rem] text-white">mazikeen</p>
              <a
                href="https://www.gianpinili.com"
                className="text-[1.25rem] text-white"
                target="_blank"
                rel="noreferrer"
              >
                <Instagram className="hover:scale-110 hover:duration-150" />
              </a>
            </div>
          </div>
        </div>
        <div className="relative rounded-[5px] border-2 border-[#747474] md:w-[16rem] lg:w-[18rem] xl:w-[22rem]">
          <img className="rounded-[5px] w-full md:max-h-[16rem] lg:max-h-[20rem] object-cover" src={Person} alt="tristan" />
          <div className="overlay absolute inset-0 rounded-[5px] bg-[#e4995d] opacity-20 hover:opacity-90 transition-opacity duration-300">
            <div className="flex flex-col justify-between h-full p-4">
              <p className="text-[1.25rem] text-white">dani jones</p>
              <a
                href="https://www.gianpinili.com"
                className="text-[1.25rem] text-white"
                target="_blank"
                rel="noreferrer"
              >
                <Instagram className="hover:scale-110 hover:duration-150" />
              </a>
            </div>
          </div>
        </div>
        <div className="relative rounded-[5px] border-2 border-[#747474] md:w-[16rem] lg:w-[18rem] xl:w-[22rem]">
          <img className="rounded-[5px] w-full md:max-h-[16rem] lg:max-h-[20rem] object-cover" src={Person} alt="tristan" />
          <div className="overlay absolute inset-0 rounded-[5px] bg-[#1a1a1a] opacity-20 hover:opacity-90 transition-opacity duration-300">
            <div className="flex flex-col justify-between h-full p-4">
              <p className="text-[1.25rem] text-white">eve jones</p>
              <a
                href="https://www.gianpinili.com"
                className="text-[1.25rem] text-white"
                target="_blank"
                rel="noreferrer"
              >
                <Instagram className="hover:scale-110 hover:duration-150" />
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Team;
